import React from 'react';

export interface ParallaxBgProps {
  children: React.ReactNode;
  bgImage: string;
  className?: string;
  id?: string;
}

export const ParallaxBg: React.FC<ParallaxBgProps> = ({ children, bgImage, className = '', id }) => {
  return (
    <div
      id={id}
      className={`relative overflow-hidden ${className}`}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {children}
    </div>
  );
}; 